import { render, staticRenderFns } from "./lottieView.vue?vue&type=template&id=27b136cb&scoped=true&"
import script from "./lottieView.vue?vue&type=script&lang=js&"
export * from "./lottieView.vue?vue&type=script&lang=js&"
import style0 from "./lottieView.vue?vue&type=style&index=0&id=27b136cb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b136cb",
  null
  
)

export default component.exports